import React from 'react';

import { useOffersData } from '../../../../hooks';
import { classNames } from '../../../../services/classNames';
import { Offer } from '../../../Offer';

export const BankOfferContent = ({ popupOffers }: any) => {
    const { cmsOffers } = useOffersData();

    if (!cmsOffers || !popupOffers) {
        return null;
    }

    /**
     * Currently UpscoreAPI returns an array of offers name. This function
     * allows us to get offer data from CMS that matches provided offer's slug
     * @param {String} slug */
    const getOfferData = (slug: any) =>
        cmsOffers.find((o: any) => o.slug.toLowerCase() === slug.toLowerCase());

    return (
        <div
            className={classNames(
                'FactorOfferPopup',
                'FactorOfferPopup--popup',
                `FactorOfferPopup--bank_offer`,
            )}
        >
            {popupOffers.map(
                (slug: any, index: any) =>
                    slug && (
                        <Offer
                            offer={getOfferData(slug)}
                            key={slug}
                            index={index}
                            separator={index !== popupOffers.length - 1}
                        />
                    ),
            )}
        </div>
    );
};
